import { sandboxBaseUri } from '@gonfalon/constants/constants';
import { trackError } from '@gonfalon/telemetry/trackError';

// path is after the baseUrl
// no leading or trailing slashes needed
export function getSandboxUrl(path: string = '') {
  try {
    return new URL(path.replace(/^\//, ''), sandboxBaseUri()).toString().replace(/\/$/, '');
  } catch (e) {
    if (e instanceof Error) {
      trackError(e, { severity: 'low' });
    }

    return 'https://demo.app.launchdarkly.com';
  }
}
